import React from 'react';
import { motion } from 'framer-motion';
import Contact from '../sections/Contact.js';
import { pageWrapperStyle } from '../../styles/pageStyles.js';

const ContactPage = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      style={{ ...pageWrapperStyle, paddingTop: 0 }}
    >
      <Contact />
    </motion.div>
  );
};

export default ContactPage;
